import { cva, type VariantProps } from 'class-variance-authority';

export const chipCva = cva(
  [
    'group flex h-8 min-h-8 w-fit flex-row shrink-0 items-center',
    'justify-center rounded-sm px-3 gap-1 transition-all select-none text-sm font-medium',
  ],
  {
    variants: {
      appearance: {
        default: 'bg-neutral-50 text-neutral-900',
        filled: 'bg-neutral-900 text-white',
      },
      selected: {
        true: 'bg-neutral-900 text-white',
      },
      dismissable: {
        true: '',
      },
    },
    defaultVariants: {
      appearance: 'default',
    },
  },
);

export const chipTrailingIconCva = cva('transition-colors', {
  variants: {
    appearance: {
      outlined: 'text-current',
      filled: 'text-white group-hover:text-neutral-50',
    },
    selected: {
      true: 'text-white group-hover:text-neutral-50',
    },
    dismissable: {
      true: '',
    },
  },
  defaultVariants: {
    appearance: 'outlined',
  },
});

export type ChipVariants = VariantProps<typeof chipCva>;
